import { Box, Button, Typography } from '@mui/material';
import Card from '@src/main/ui/components/common/Card/Card';
import Modal from '@src/main/ui/components/common/Modal/Modal';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import React, { type FC } from 'react';
import { useParams } from 'react-router-dom';

interface Props {
  id: string;
  name: string;
  onClose: () => void;
}

const AdminAddDashboardAreaConfirmDeleteModal: FC<Props> = ({ id, name, onClose }) => {
  const { deleteArea } = useAreaContext();
  const { areaId, subareaId } = useParams();

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deleteArea({
      areaId,
      subareaId: subareaId || id,
      subsubareaId: subareaId ? id : undefined,
    });
    onClose();
  };

  return (
    <>
      <Modal open handleClose={onClose}>
        <Card width="90vw" maxWidth="650px" maxHeight="75vh">
          <form onSubmit={submit}>
            <Box
              sx={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <Typography variant="h5">Delete area</Typography>
              <Typography>Are you sure to delete the area &apos;{name}&apos;?</Typography>
              <Button
                sx={{
                  width: 'fit-content',
                  alignSelf: 'flex-end',
                }}
                type="submit"
                color="secondary"
                variant="contained"
              >
                Delete
              </Button>
            </Box>
          </form>
        </Card>
      </Modal>
    </>
  );
};

export default AdminAddDashboardAreaConfirmDeleteModal;
